module.exports = (function () {
  return `
    {{#sensorVariables}}
    if (!{{sensorVariable}}) {
      {{sensorVariable}} = hmSensor.createSensor(hmSensor.id.{{sensorId}})
    }
    {{/sensorVariables}}
  `
})()
